import { NewDealSolarProduct } from "../model/solar-product/new-deal-solar-product";
import { SolarProductWithRecommendations } from "../model/solar-product/solar-product-with-recommendations";
import { apiSlice } from "../stores/base/api-slice";

const solarProductEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		viewProduct: builder.query<SolarProductWithRecommendations, string>({
			query: id => ({
				url: `/solar-product/get-product-details`,
				params: { id },
				method: "GET",
			}),
			providesTags: (result, error, id) => [{ type: "SolarProducts", id }, "SolarProducts"],
		}),
		newDeals: builder.query<NewDealSolarProduct[], void>({
			query: () => ({
				url: `/solar-product/new-deals`,
				method: "GET",
			}),
			providesTags: ["SolarProducts"],
		}),
	}),
});

export const { 
	useLazyViewProductQuery,
	useLazyNewDealsQuery,
} = solarProductEndpoints;
